<template>
    <div class="knowledge-list flex-center-hori">
        <div class="tree-wrapper">
            <AppTree :list="treeList" @node-click="treeNodeClick" :defaultProps="directoryDefaultProps">
                <div class="add-directory" slot="treeTop">
                    <AppTitle title="类目"/>
                </div>
                <div class="directory-item" slot-scope="{ nodeData }">
                    <div class="text-overflow directory-item_label">{{nodeData.catName}}</div>
                </div>
            </AppTree>
        </div>
        <KnowledgeListContent v-if="currentDirectoryItem" :directoryInfo="currentDirectoryItem"
                              @onDetailShow="onDetailShow"/>
        <AppEmpty v-else text="类目列表为空无法查看"></AppEmpty>
    </div>
</template>

<script>
import KnowledgeListContent from './KnowledgeListContent.vue';
import AppEmpty from './AppEmpty.vue';
import AppTitle from './AppTitle.vue';
import AppTree from './AppTree.vue';
import { deepCloneByCondition } from '../../../utils/json';
export default {
    name: 'knowledge-list',
    components: {
        KnowledgeListContent,
        AppEmpty,
        AppTitle,
        AppTree
    },
    data () {
        return {
            directoryDefaultProps: {
                children: 'childrenCatalogList',
                label: 'catName',
                key: 'assistantId_catId'
            },
            currentDirectoryItem: null,
            currentOperateDirectoryItem: {},
            treeList: []
        };
    },
    created () {
        this.init();
    },
    methods: {
        async init () {
            // 获取目录树
            let respond = await this.$api.knowledgeApi.getTree();
            let list = respond.data.data || [];
            this.treeList = deepCloneByCondition({
                obj: list,
                emptyArrAsNull: true,
                addKeyName: 'assistantId_catId',
                addKeyValueBy: ['assistantId', 'catId']
            });
            if (!this.treeList || !this.treeList.length) {
                this.currentDirectoryItem = null;
            }
        },
        // 目录树选项点击设置当前选中项
        treeNodeClick (node) {
            this.currentDirectoryItem = node;
        },
        onDetailShow (data) {
            this.$emit('setLoading', true);
            this.$api.knowledgeApi.getDraftDocument(data.documentId).then((res) => {
                if (typeof data === 'object') {
                    let item = {
                        ...data,
                        knowledgeUrl: res.data.data.documentUrl,
                        knowledgeType: +data.knowledgeType
                    };
                    this.$emit('setKnowledgeData', item);
                }
                this.$emit('setLoading', false);
            }).catch(() => {
                this.$emit('setLoading', false);
            });
        }
    }
};
</script>

<style scoped lang="scss">
.knowledge-list {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 0;
    justify-content: space-between;
    overflow: hidden;
    background: var(--knowledge-right-bg);
    .tree-wrapper {
        width: 240px;
        height: 100%;
        border-radius: 4px;
        padding-bottom: 24px;
        background: var(--knowledge-right-bg);
        flex-shrink: 0;
        ::v-deep {
            .el-tree {
                width: calc(100% + 12px); // 设置多出滚动条的宽度
                background: transparent;
                color: var(--knowledge-text);
            }
        }
        .directory-item {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .directory-item_label {
                width: calc(100% - 30px);
            }
        }
    }
    .knowledge-list-content {
        flex: 1;
    }
}
</style>
